import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CheckIcon from '@mui/icons-material/Check';
import Logo from '../Logo/Logo.component';
import useTranslation from '../../translations/use-translation';
import './UserTypeSelector.styles.scss';

const CUSTOMER_FEATURES = [
    'Apply for government services',
    'Track your applications',
    'Upload & verify documents',
];

const CSC_FEATURES = [
    'Register & manage your CSC center',
    'Add services for customers',
    'Handle service requests',
];

const UserTypeSelector = ({ onSelect, onClose }) => {
    const translate = useTranslation();

    return (
        <div className="uts">

            {/* ── Header ── */}
            <div className="uts__header">
                <div className="uts__header-top">
                    <div className="uts__brand-row">
                        <Logo width="26px" />
                        <span className="uts__brand-name">{translate('ONLINE_APPLICATIONS')}</span>
                    </div>
                    <button
                        className="uts__close"
                        onClick={onClose}
                        type="button"
                        aria-label="Close"
                    >
                        <CloseIcon fontSize="small" />
                    </button>
                </div>
                <h2 className="uts__title">{translate('SIGN_IN_AS')}</h2>
                <p className="uts__subtitle">{translate('CHOOSE_ACCOUNT_TYPE')}</p>
            </div>

            {/* ── Option cards ── */}
            <div className="uts__options">

                {/* Customer */}
                <button
                    type="button"
                    className="uts__option uts__option--customer"
                    onClick={() => onSelect('customer')}
                    aria-label="Continue as Customer"
                >
                    <div className="uts__option-top">
                        <span className="uts__option-icon uts__option-icon--customer">
                            <PersonOutlineIcon />
                        </span>
                        <ArrowForwardIcon fontSize="small" className="uts__option-arrow" />
                    </div>
                    <div className="uts__option-body">
                        <span className="uts__option-type">{translate('CUSTOMER_CARD_TITLE')}</span>
                        <span className="uts__option-desc">{translate('CUSTOMER_CARD_DESC')}</span>
                    </div>
                    <ul className="uts__option-features">
                        {CUSTOMER_FEATURES.map((f) => (
                            <li key={f} className="uts__option-feature">
                                <CheckIcon className="uts__feature-check" />
                                {f}
                            </li>
                        ))}
                    </ul>
                </button>

                {/* CSC Owner */}
                <button
                    type="button"
                    className="uts__option uts__option--csc"
                    onClick={() => onSelect('csc-owner')}
                    aria-label="Continue as CSC Owner"
                >
                    <div className="uts__option-top">
                        <span className="uts__option-icon uts__option-icon--csc">
                            <StorefrontOutlinedIcon />
                        </span>
                        <div className="uts__option-top-right">
                            <span className="uts__option-badge">Business</span>
                            <ArrowForwardIcon fontSize="small" className="uts__option-arrow" />
                        </div>
                    </div>
                    <div className="uts__option-body">
                        <span className="uts__option-type">{translate('CSC_OWNER_CARD_TITLE')}</span>
                        <span className="uts__option-desc">{translate('CSC_OWNER_CARD_DESC')}</span>
                    </div>
                    <ul className="uts__option-features">
                        {CSC_FEATURES.map((f) => (
                            <li key={f} className="uts__option-feature">
                                <CheckIcon className="uts__feature-check" />
                                {f}
                            </li>
                        ))}
                    </ul>
                </button>

            </div>
        </div>
    );
};

export default UserTypeSelector;
